import React from 'react';

const Trope4: React.FC = () => {
  return (
    <g
      className="prefix__trope-decor-4 prefix__trope-decor"
      transform="translate(120, 236)"
    >
      <g id="bb8051e6-81de-4556-8e32-0324356861e3" data-name="road">
        <path
          d="M696.36,59,677.5,73s-101-12-125,8-42,53-65,48-115,5-164,37-245,46-249,107,75,53,75,53l23,3c9,11,70,19,92,30l12,23c-30-18-111-26.17-166-37C47,332.5,56,263.5,56,263.5c3-33-56-31-56-31l25-8c20.37,7.41,48.11-.67,52.12-1.92,35.81-26.28,119-40.77,135.38-50.58,20-12-17-19-17-19l27,1c12,9,54,5,113-27s133-18,142-21-8-13-8-13l11-8a67,67,0,0,0,24,7c13,1,10-7,48-25S696.36,59,696.36,59Z"
          fill="#415c93"
        />
        <path
          d="M268,368.5s-94-25-141-32-74-39-58-79,112-66,181-82,108-52,157-56,81,1,96-8,30-27,44-35,41-18,82-14S688,65,688,65"
          fill="none"
          stroke="#dcceea"
          strokeMiterlimit="10"
          strokeDasharray="12"
        />
        <path
          d="M1033,138.5c57,4,112.5,5.5,169.5,48.5s27,80-3,85-174-15-193,31,43,77,157,61c0,0,3,10,11,17,0,0-45,28-50,47,0,0-19-15-28-6s40-24,30-31-152-14.62-155.5-65.5c-2-29,16.5-63.5,101.5-68.5s125.62,9.66,133-17c18-65-212-85-212-85Z"
          fill="#415c93"
        />
        <path
          d="M1016.57,145.36S1135.5,151,1184.5,188s53,66,10,75-143-12-183,20-30,57-6,69,98,32,149,25c0,0-31,34-35,40"
          fill="none"
          stroke="#dcceea"
          strokeMiterlimit="10"
          strokeDasharray="12"
        />
        <path
          d="M1034.54,138.08l-39,16.56c-14-8.37-69.38-1.6-107.53-11.14-24-6-20.5-23.5-44.5-48.5s-73-17-73-17l13.39-21.4S806.5,55,851.5,73c20.84,8.33,26,20.31,28.66,30.38-.16-1.19-.25-2-.27-2.23C880.74,106,905.54,105,914.5,98h19s-39.36,22.7-22.68,23.35c1,0,1.77.09,2.41.17h0C953.64,122.47,1034.54,138.08,1034.54,138.08Z"
          fill="#415c93"
        />
        <path
          d="M1011.24,146.49C995,139,976.7,138.47,944.5,135c-30-3.24-52.25,10.05-69.5-24.5C861.72,83.9,847.5,83,822.5,73s-45.67-7-45.67-7"
          fill="none"
          stroke="#dcceea"
          strokeMiterlimit="10"
          strokeDasharray="12"
        />
      </g>
      <g id="a562d53b-4c24-4adf-9dab-031c42e05f75" data-name="decor">
        <g>
          <line
            x1="244.21"
            y1="399.41"
            x2="258.27"
            y2="391.36"
            fill="none"
            stroke="#72bdc1"
            strokeMiterlimit="10"
            strokeWidth="0.64"
          />
          <path
            d="M255.27,388.43l-17.91-10.34a7.66,7.66,0,0,1-2.48.4l.08.06,22.11,12.76a.76.76,0,0,0,.4.11.85.85,0,0,0,.35-.08A17.73,17.73,0,0,0,255.27,388.43Z"
            fill="#548e8c"
          />
          <path
            d="M257.7,391.59a.85.85,0,0,1-.4-.1l-22.11-12.77a.81.81,0,0,1-.4-.69.78.78,0,0,1,.4-.69L246.25,371a.8.8,0,0,1,1.09.29l11,19.16a.8.8,0,0,1-.12,1A.83.83,0,0,1,257.7,391.59ZM237.18,378l18.34,10.59-9.17-15.89Z"
            fill="#72bdc1"
          />
          <path
            d="M258.39,390.4l-11-19.15a.79.79,0,0,0-.36-.32c-.31.75-.79,1.33-1.1,2.08l.47-.27,9.17,15.88h0a17.66,17.66,0,0,1,2.55,2.9.78.78,0,0,0,.22-.15A.8.8,0,0,0,258.39,390.4Z"
            fill="#9cd8d8"
          />
          <g>
            <path
              d="M253.48,368.38c-5.33-3.05-9.67-.54-9.64,5.57s4.39,13.61,9.69,16.67,9.65.56,9.65-5.56S258.81,371.43,253.48,368.38Z"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="1.95"
            />
            <path
              d="M253.48,377.34c-1-.6-1.89-.11-1.88,1.09a4.18,4.18,0,0,0,1.89,3.26c1,.6,1.89.11,1.89-1.09A4.16,4.16,0,0,0,253.48,377.34Z"
              fill="#6986a3"
            />
            <path
              d="M285.81,387c-5.34-3.05-9.68-.54-9.65,5.56s4.39,13.62,9.7,16.68,9.64.56,9.64-5.57S291.14,390,285.81,387Z"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="1.95"
            />
            <path
              d="M285.81,395.32c-1.35-.77-2.44-.14-2.43,1.4a5.41,5.41,0,0,0,2.44,4.2c1.33.77,2.43.14,2.43-1.4A5.38,5.38,0,0,0,285.81,395.32Z"
              fill="#6986a3"
            />
            <polyline
              points="245.96 368.35 253.48 379.46 262.01 382.78"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <polyline
              points="260.22 391.62 253.53 380.59 262.01 387.54"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <polyline
              points="253.99 368.67 253.48 379.46 249.5 368"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <polyline
              points="259.23 375.53 253.48 379.46 256.87 371.59"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <polyline
              points="261.57 379.01 253.48 379.46 253.99 390.36"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <line
              x1="252.98"
              y1="379.78"
              x2="250.68"
              y2="388.05"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <line
              x1="252.7"
              y1="379.01"
              x2="248.67"
              y2="385.06"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <line
              x1="251.97"
              y1="379.01"
              x2="245.96"
              y2="380.59"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <line
              x1="251.6"
              y1="378.37"
              x2="244.91"
              y2="377.1"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <line
              x1="252.47"
              y1="377.96"
              x2="244.39"
              y2="372.75"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <line
              x1="276.16"
              y1="392.55"
              x2="294.76"
              y2="404.09"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <polyline
              points="279.12 386.41 285.81 398.32 277.31 388.87"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <polyline
              points="284.83 386.99 285.46 397.71 282.46 386.41"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <polyline
              points="290.9 392.06 285.81 398.32 288.25 389.24"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <polyline
              points="292.49 395.08 285.81 398.32 294.15 399.16"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <path
              d="M294.76,407c-.33-.19-7.94-7.79-7.94-7.79"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <polyline
              points="288.25 409.26 285.81 398.32 292.11 409.26"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <polyline
              points="284.56 408.48 285.81 398.32 282.46 405.62 280.14 403.06 285.81 398.32 277.31 396.33"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <line
              x1="278.1"
              y1="400.05"
              x2="285.18"
              y2="398.58"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <line
              x1="263.49"
              y1="357.22"
              x2="253.48"
              y2="379.46"
              fill="none"
              stroke="#e2b55a"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.11"
            />
            <path
              d="M258.48,368.35s8.41,2.24,9.89,19.7l17.44,10.27S284,369.07,258.48,368.35Z"
              fill="none"
              stroke="#e2b55a"
              strokeLinejoin="round"
              strokeWidth="1.11"
            />
            <polyline
              points="281.64 374.4 272.14 390.23 269.19 392.72 272.14 397.12"
              fill="none"
              stroke="#e2b55a"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.11"
            />
            <polyline
              points="258.49 362.84 258.49 360.08 267.97 354.42 272.82 354.42"
              fill="none"
              stroke="#ff9a76"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.11"
            />
            <polygon
              points="276.89 370.7 283.37 377.1 285.42 374.4 276.89 370.7"
              fill="#ff9a76"
              stroke="#ff9a76"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.11"
            />
            <path
              d="M276.16,392.55s-4.46.74-5.76-.93-.83-5.24,1.74-4.12S276.16,392.55,276.16,392.55Z"
              fill="#e2b55a"
              stroke="#e2b55a"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.11"
            />
            <path
              d="M270.68,396.33c-.82.34-3.32,1.56-3.32,1.56l2.34,1.43,3.23-1.61Z"
              fill="#ff9a76"
            />
            <polygon
              points="267.36 397.89 267.36 398.58 269.69 399.95 269.7 399.32 267.36 397.89"
              fill="#f2bdad"
            />
            <polygon
              points="272.93 397.71 272.93 398.32 269.69 399.95 269.7 399.32 272.93 397.71"
              fill="#a56556"
            />
          </g>
          <g opacity="0.62">
            <path
              d="M249.4,410.32c-5-2.49-5.66-7-1.45-10s11.75-3.5,16.76-1,5.65,7,1.45,10S254.41,412.82,249.4,410.32Z"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <path
              d="M255.55,405.85c-1-.48-1.11-1.37-.28-2a3.54,3.54,0,0,1,3.28-.2c1,.48,1.1,1.36.28,2A3.48,3.48,0,0,1,255.55,405.85Z"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <path
              d="M279.86,425.37c-5-2.5-5.66-7-1.45-10s11.75-3.49,16.76-1,5.65,7,1.45,10S284.87,427.86,279.86,425.37Z"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <path
              d="M285.58,421.21c-1.26-.63-1.42-1.77-.36-2.53a4.53,4.53,0,0,1,4.21-.26c1.26.62,1.43,1.76.37,2.53A4.52,4.52,0,0,1,285.58,421.21Z"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="245.27 404.68 257.01 404.79 263.95 409.56"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="269.05 403.79 257.81 404.27 267.23 407.18"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="249.87 410.56 257.01 404.79 246.96 407.52"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="257.45 411.08 257.01 404.79 253.46 411.27"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="261.12 411.11 257.01 404.79 264.77 399.73"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <line
              x1="256.95"
              y1="404.26"
              x2="261.38"
              y2="398.4"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <line
              x1="256.27"
              y1="404.43"
              x2="258.22"
              y2="398.38"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <line
              x1="255.87"
              y1="403.88"
              x2="253.67"
              y2="398.57"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <line
              x1="255.23"
              y1="403.92"
              x2="250.7"
              y2="399.52"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <line
              x1="255.42"
              y1="404.78"
              x2="247.43"
              y2="401.3"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <line
              x1="278.41"
              y1="415.33"
              x2="296.5"
              y2="423.57"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="275.8 420.62 287.64 419.71 276.5 418.04"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="279.32 424.63 287.04 419.75 277.63 423.14"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="286.13 426.67 287.64 419.71 282.74 426.08"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="289.07 426.36 287.64 419.71 292.78 425.57"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <path
              d="M298.47,422.14c-.31-.16-9.7-2.09-9.7-2.09"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="296.49 416.08 287.64 419.71 298.61 418.99"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="293.94 413.7 287.64 419.71 290.83 413.55 287.8 413.08 287.64 419.71 281.63 414.31"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <line
              x1="284.62"
              y1="413.05"
              x2="287.48"
              y2="419.1"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <line
              x1="247.2"
              y1="423.43"
              x2="257.01"
              y2="404.79"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <path
              d="M252.11,414.1s6.14,5.21,18.94-2.39l16.59,8S266.54,432.92,252.11,414.1Z"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="268.93 428.51 274.62 413.46 274.71 410 279.35 410.02"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="248.33 416.86 246.43 418.24 247.72 428.2 250.38 431.85"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polygon
              points="263.79 426.79 271.73 428.47 271 431.36 263.79 426.79"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <path
              d="M278.41,415.33s-1.93-3.73-3.79-3.87-4.06,2-1.88,3.37S278.41,415.33,278.41,415.33Z"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <path
              d="M278,409.32c-.22-.79-.74-3.28-.74-3.28l2.25,1,.66,3.23Z"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polygon
              points="277.27 406.04 277.74 405.7 279.95 406.76 279.52 407.09 277.27 406.04"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polygon
              points="280.18 410.32 280.6 410.02 279.95 406.76 279.52 407.09 280.18 410.32"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
          </g>
          <path
            d="M252.38,391l-17.91-10.34a7.66,7.66,0,0,1-2.48.4l.08.06,22.11,12.76a.76.76,0,0,0,.4.11.77.77,0,0,0,.36-.09A18.65,18.65,0,0,0,252.38,391Z"
            fill="#72bdc1"
          />
          <path
            d="M252.38,390.92l-17.91-10.35a7.4,7.4,0,0,1-2.48.4l.08.06,22.11,12.77a.85.85,0,0,0,.4.1.9.9,0,0,0,.36-.08A18.2,18.2,0,0,0,252.38,390.92Z"
            fill="#548e8c"
          />
          <path
            d="M247.5,397.81a.8.8,0,0,1-.4-.11L225,384.93a.79.79,0,0,1-.39-.69.81.81,0,0,1,.39-.69L236,377.17a.79.79,0,0,1,1.09.29l11.06,19.15a.79.79,0,0,1-.13,1A.77.77,0,0,1,247.5,397.81ZM227,384.24l18.34,10.59L236.15,379Z"
            fill="#72bdc1"
          />
          <path
            d="M242.18,397.18l-17.92-10.34a7.6,7.6,0,0,1-2.47.4l.07.06L244,400.07a.79.79,0,0,0,.4.1.85.85,0,0,0,.35-.08A17.73,17.73,0,0,0,242.18,397.18Z"
            fill="#72bdc1"
          />
          <path
            d="M245.07,394.65,227.15,384.3a7.34,7.34,0,0,1-2.47.4l.07.06,22.12,12.77a.8.8,0,0,0,.4.11.86.86,0,0,0,.35-.09A17.66,17.66,0,0,0,245.07,394.65Z"
            fill="#548e8c"
          />
          <path
            d="M234.06,380.39l8.71-5c.3-.75.78-1.33,1.09-2.08a.76.76,0,0,0-.73,0l-11.06,6.38a.81.81,0,0,0-.4.69.79.79,0,0,0,.32.64,7.66,7.66,0,0,0,2.48-.4Z"
            fill="#69afad"
          />
          <path
            d="M242.18,397.18l-17.92-10.34a7.6,7.6,0,0,1-2.47.4l.07.06L244,400.07a.79.79,0,0,0,.4.1.85.85,0,0,0,.35-.08A17.73,17.73,0,0,0,242.18,397.18Z"
            fill="#548e8c"
          />
          <path
            d="M245.07,399,234,379.83a.79.79,0,0,0-.35-.33c-.31.76-.79,1.33-1.1,2.08l.47-.27,9.17,15.89,0,0a17.73,17.73,0,0,1,2.55,2.91.8.8,0,0,0,.21-.15A.79.79,0,0,0,245.07,399Z"
            fill="#9cd8d8"
          />
          <path
            d="M248.19,396.62l-11.06-19.16a.75.75,0,0,0-.36-.32c-.3.75-.78,1.33-1.09,2.08l.47-.27,9.17,15.89,0,0a17.73,17.73,0,0,1,2.55,2.91.8.8,0,0,0,.21-.15A.79.79,0,0,0,248.19,396.62Z"
            fill="#9cd8d8"
          />
          <path
            d="M223.86,386.61l8.7-5c.31-.75.79-1.32,1.1-2.08a.84.84,0,0,0-.74,0l-11.06,6.39a.79.79,0,0,0-.07,1.32,7.6,7.6,0,0,0,2.47-.4Z"
            fill="#69afad"
          />
          <path
            d="M255.27,392.76l-11.05-19.15c-.72-.61-.72-.61-1.72.39-.31.75.57.62.27,1.37l.46-.27L252.4,391h0a18.65,18.65,0,0,1,2.56,2.9.85.85,0,0,0,.21-.14A.81.81,0,0,0,255.27,392.76Z"
            fill="#9cd8d8"
          />
        </g>
        <g>
          <image
            width="97"
            height="96"
            transform="translate(127.5 301)"
            xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGEAAABgCAYAAAANWhwGAAAACXBIWXMAAAsSAAALEgHS3X78AAALBUlEQVR4Xu2b327cRpaHv9+pItndktaJxx3DGQMTBN698GAvFn6A+CX0PImfRw+wt3oBXy2gmw2CWURANpbW/9pSq8mqc/aiJdnOZCZXk6Z3+QkE1CBBkPXVOfWXiggmdov91gUT/3gmCSNgkjACJgkjYJIwAiYJI2CSMAImCSNgkjACJgkjYJIwAiYJI2CSMAImCSNgkjACJgkjYJIwAiYJI2CSMAImCSNgkjACJgkjYJIwAiYJI2CSMAImCSNgkjAC8m9dMFok3f7/iW+o/XQkSIJtWT/jmb7luw/OfXThJydl3OlIEjd/fCc4MsC+4Rvj+jjmGwPs+pye8d319Z8OGm2lEYJngm+3vzjWCWf2mD8Drf7CqQC+4mFAH7AOWAWcBZwEfBsEI325jxmfhPe1WNvjuX3PC3vEXHBgZ8uVKZrbmh4aYnl24Kf0ccVrf8OP/oTP/VMSMR4J73O+4EhwKDixU96kh/f37OWwTqkOybw1SDoAVsCBen9tG/8sN5XzWYUXFX50bkV8F2NvI8YhQbrO+d8Cx7ZNO0v7+f7ddH9Yp7fFs80jW+2SvCQwKUwhj0sVnyUrvlY5aGLgZS5bEfMKTx0YfTTsXsJt7n8sWOp71ukR/2rn9/4rN0PkNN/LVmisrBu1Xe49sqIYQKPsGw21HWaDZ+8Xm9q/bGK4+9IHOK1AhUMfu4Td9o4+EvC1wcN0cD9l7l413aZpc9t1eePzoqtFsbRXqPuJum+kfSPtV7SXZAvlOrMydJddanPxzHKT4N8Ey+39PxxTjJDdjRNuU9CNgFXifpO6Tdu8m62arNrKUjsYXVLqJLWCRlIma1t5aq2h3Be55Zyxits86qv+oH7OWYUD395/1+H+99mdhNsMcSx4YdxP6fXmZZO7tk1931puu2HwWTI6QVdVu4bcVMgUNxQRyiVqpJSMEsWzvKaiul/7crbcpOXZ0mEZ3PS5RpqWdpuOOBKcGdT0qrecZ6lJQ2otNTMp5qZhYWKhqkWjPK/O3FXmbjGTmi7LO5l3cu/kauVdozrLFzNrluUg/cSbBF8YXKe9kQ7idhMJuhkDLPUXsK+WWL6q2dJ+Y9m7QT6zEnOz2axqmGXl1lVbh5wiWTUXXt1BcqImVQuKKIMsihXqqqzqg3sP/PT8ZbzliBd840/Btxo0qqmN3fSOhI44skO+Nujzq8/btmk3Xbb5vPSbhUkLU55XlblcnYyGSBmL5LgloEKYpxKqA+EbD9YecWkel03bXtaq9aKfb2hfDZxbgTsVXvgRZ3E4soHcztLRIXDCD+LLVuZrs9qlTV3nNjdZiaZYbRWpwVImyERJgBIJAMMAN2GJSFmmVpY6S6kbhjqzVGeX7bpbbZr25V1r+HKdYZ2+5mvbNtbjSU+7SUfXPObP/FyL5tFL0Zsi2RCeTCkJEhZJUROYbupLEAGGVycIJbLJPOMKswgjBybKUNU0IbXV1Mzs9eUbG5bz8uRsVU5AH6WnHUfEziLh11BIokhRBVUgcV3zK5VaiVoJKmFYCAmLRKhxi06yWVXdM9W9pLJX0J6ZLfLG500777pN157fa5rHPExP+cKOOd422juOiJ1GwgnwB/6bf9KDuFSJVuFrFEk1WmWv1RyrARFJjVeqElDDlUjCZB4hBFnZi3tG3jg5GSlb1FTxnI202WxS0+5daVPFvTtw/pKnfAE3feUdRsTOIuEIeMw67v984K/1PxEqfmXuC1PJakpUVTR4IRyZ3wy4bgS41QRKBI1C7eB1LnwhtOeUA89xYKQDI+0X1f2U5os0xDx1Q7favGm55/mUNwme27arvDt2FAnikO/ieiAVbnOPlGu38YJRQqUUqZgoyTHMBVhCODK3MCInUbOLrO05OcJQFTQRtXEiB5YNkoQN1qsZOhad4m1f4+FyE4xgQLcbCRFxnYXje/49HjV369vLi+qtF9lsyMq9CrmqZMlTKCeFQ4RhkVIoeZDd1BCRIzyRkhSucHmIxpSyu6dACcJcoc6aCFW/KuFpZs5wUGF2Pb1xJDj83QXADtMRwBFHPOILP/35wku24nkxxHA1RI0+W/TJUh9SoW4NCERY8qBx85agkWgwNfj2N+atFJ17zELMBQuXFoYW1ZgXyzNla63QrErNZ8vvE7ywbad5N+xQgjjkJI5ZxUPu1KGZ17q+KDW3fSTvo0afa/TJY0BeUQpMSsgwcgpykmUgE0ogA5lHJFCSaAi1oegkdTJ1VT5TUjska9VG1qKkVOcGc23nsHYz47qbEfMNt9MXGBzn83tNc2/TtOu2m5ldLUxaFHzf0Z6hPUeLFJo5zGQ0Ht4Q2LYr6wILiHARhipBCTEoWAdcGloZvqpolWWrEn6xV2zNq76HtsCTyg4WgXYYCVsHz3gGHMUJZ37v/E/lVU6l5oshhtpH9T67bcIZwlXCVR0CRXgFUCBzFI5UEAUxmGwgKEE4hAMQLsKNkLVImyimMBFJP33Z/u61/0N20zBfE+8baB5z7N/zH3rU/rFw1dpl06eNbXJGTcI2TrSg1mBwVzZh7o6lBK4A8yDcRVjIERFSmFNCtYAqbLu6w994niOOdLiDxnmnEoBt8Avgqb/hufj5ZeVeU+pmNtSm9GZtFrVJWOMoh5RCYYSHLJeICmaORw2iCvl2aiNCQUTIAxUL24QxBJTAatB7YPGaFQ+sC2jZhQDYcTq64SYtPeEHhzP/6XxWDzJDl7u+yWXj2a76VK881XVEXRtchnFpxEVgF4beOfHOpJXQW4m3Ll9JWol4Z9hFWF2n8Kvw6KMMpUvzEjb4Zzb301OA57dP83uz+0jg47QEx/6AF5X2j6rrfli3ng7MUyElU6gmMC9VSn2EmyC8qppUHEqSaqklGlIUIEOA+UDUEtGnZFeNaeP9VYk+V2aX/pC1w78EPPs7T/mPY7e9o19y3Vt6zvP0hFU6v9c03Wbocvt5Z1bnRcPCLM1K9a6JlElulAikGqaCVKLWCsnhfeYPJUfuUZvBbTM0ddjUJm/2+27DKwb4obDDnRmjiIRbrtuHJ/zgJ6DH5w8Ld+d617wVfauccwx4rdQhQSqlGuTI1BqoNENbwqKi5BvK7W07UiB5tKrRU2qTh/3Noj9rXtcL8K9YOjz93Qv/hlG0CR8j4CResHS4U3+a5TJsFn2Z5avqts7UC8Pe1ajvDK2ErSr2Liu9c19fuNeLGnGRo9weNeKieFwWX69Ln67Kpu/PmtdlefZV+YqDut2/+oxdtAcwtnR0w+0g7tjgC+PLdX55VfLdcpAvZqtG3qYrL2l+e31xt1zDBo/LXEM1QvX2xe5oP17zms9s7qQD52ztsPITzvwxhxWe7XS5c5wS4K9F8CaxvJMo6/S29kmxMTgAtvtRsbljm20h22mQ/vDxi9n94PRHYOnvd3E/8VsBaGeL/+OVAB+JOOHMFiyt48Ae3G+EZ53HKwEf7cwubKKwjke8C/j6V15uFfA0jjjidsF/hwJg7BLgAxFH2m5rPNB21vOfgVPBw4D/BP4U779ReBrbZaMP+XAg9oxt4bOT9YNfMn4JcC3i5oORIx2z1NO/uujs+kUO46NC/lV2W/N/yachAfjwm7WtkF/yYaGPq5B/i09Hwof8rTn/T/JlPlUJ/8cY4WDt/x+ThBEwSRgBk4QRMEkYAZOEETBJGAGThBEwSRgBk4QRMEkYAZOEETBJGAGThBEwSRgBk4QRMEkYAZOEETBJGAGThBEwSRgBk4QRMEkYAZOEETBJGAGThBEwSRgBk4QR8L/U5gsO8h4KDQAAAABJRU5ErkJggg=="
          />
          <polygon
            points="175.94 350.55 175.94 359.48 165.39 344.45 175.94 338.36 175.94 345.88 186.5 351.87 186.5 356.64 175.94 350.55"
            fill="none"
            stroke="#f416ca"
            strokeLinejoin="round"
            strokeWidth="2.13"
          />
          <line
            x1="179.28"
            y1="353.18"
            x2="179.28"
            y2="374.5"
            fill="none"
            stroke="#f416ca"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2.13"
          />
          <line
            x1="179.28"
            y1="353.18"
            x2="179.28"
            y2="374.5"
            fill="none"
            stroke="#f7e4f4"
            strokeLinejoin="round"
            strokeWidth="0.3"
          />
          <polygon
            points="175.94 350.55 175.94 359.48 165.39 344.45 175.94 338.36 175.94 345.88 186.5 351.87 186.5 356.64 175.94 350.55"
            fill="none"
            stroke="#f7e4f4"
            strokeLinejoin="round"
            strokeWidth="0.3"
          />
        </g>
        <g>
          <polygon
            points="588.98 43.77 588.98 47.5 583.46 40.58 588.98 37.39 588.98 41.32 596 40.5 595 44.5 588.98 43.77"
            fill="none"
            stroke="#4ff219"
            strokeLinejoin="round"
            strokeWidth="1.11"
          />
          <polygon
            points="588.98 43.77 588.98 47.5 583.46 40.58 588.98 37.39 588.98 41.32 596 40.5 595 44.5 588.98 43.77"
            fill="none"
            stroke="#f7e4f4"
            strokeLinejoin="round"
            strokeWidth="0.15"
          />
          <image
            width="87"
            height="85"
            transform="translate(546.5)"
            xlinkHref="data:image/png;base64,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"
          />
          <line
            x1="591"
            y1="44.5"
            x2="590.72"
            y2="56.29"
            fill="none"
            stroke="#4ff219"
            strokeLinejoin="round"
            strokeWidth="1.11"
          />
          <line
            x1="591"
            y1="44.5"
            x2="590.72"
            y2="56.29"
            fill="none"
            stroke="#f7e4f4"
            strokeLinejoin="round"
            strokeWidth="0.15"
          />
        </g>
        <g>
          <g>
            <path
              d="M676.5,74s36-20,94,4L784,57.5S727.5,37,696.5,59Z"
              fill="#415c93"
            />
            <line
              x1="676"
              y1="51.5"
              x2="676"
              y2="73.5"
              fill="none"
              stroke="#adbcd8"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <line
              x1="725"
              y1="57.5"
              x2="725"
              y2="66.5"
              fill="none"
              stroke="#adbcd8"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <line
              x1="735"
              y1="39.5"
              x2="735"
              y2="48.5"
              fill="none"
              stroke="#adbcd8"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <line
              x1="773"
              y1="55.5"
              x2="773"
              y2="77.5"
              fill="none"
              stroke="#adbcd8"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <line
              x1="784"
              y1="35.5"
              x2="784"
              y2="57.5"
              fill="none"
              stroke="#adbcd8"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <line
              x1="696"
              y1="37.5"
              x2="696"
              y2="59.5"
              fill="none"
              stroke="#adbcd8"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <path
              d="M676,54.72s24,16.78,49-.22c0,0,15,15,48,5"
              fill="none"
              stroke="#adbcd8"
              strokeLinecap="round"
              strokeMiterlimit="10"
            />
            <path
              d="M696.49,40.38S712,54.29,735,41.39c0,0,36,16.77,49-3.56"
              fill="none"
              stroke="#adbcd8"
              strokeLinecap="round"
              strokeMiterlimit="10"
            />
          </g>
          <path
            d="M776.83,66s-36.46-17.27-86.65-2.88"
            fill="none"
            stroke="#dcceea"
            strokeMiterlimit="10"
            strokeDasharray="12"
          />
        </g>
        <g>
          <polygon
            points="842.04 125.39 852.77 131.58 852.77 119.19 863.5 137.78 852.77 143.97 852.77 136.11 842.04 130.02 842.04 125.39"
            fill="none"
            stroke="#f916ce"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.24"
          />
          <polygon
            points="842.04 125.39 852.77 131.58 852.77 119.19 863.5 137.78 852.77 143.97 852.77 136.11 842.04 130.02 842.04 125.39"
            fill="none"
            stroke="#f9eff8"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.23"
          />
          <line
            x1="847.92"
            y1="133.36"
            x2="847.92"
            y2="157"
            fill="none"
            stroke="#f916ce"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.24"
          />
          <image
            width="96"
            height="99"
            transform="translate(804.5 82)"
            xlinkHref="data:image/png;base64,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"
          />
        </g>
        <g>
          <polygon
            points="814.98 47.77 814.98 52.44 809.46 44.58 814.98 41.39 814.98 45.32 820.5 48.45 820.5 50.95 814.98 47.77"
            fill="none"
            stroke="#4ff219"
            strokeLinejoin="round"
            strokeWidth="1.11"
          />
          <image
            width="85"
            height="85"
            transform="translate(772.5 4)"
            xlinkHref="data:image/png;base64,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"
          />
          <line
            x1="816.72"
            y1="49.14"
            x2="816.72"
            y2="60.29"
            fill="none"
            stroke="#4ff219"
            strokeLinejoin="round"
            strokeWidth="1.11"
          />
          <line
            x1="816.72"
            y1="49.67"
            x2="816.72"
            y2="60.14"
            fill="none"
            stroke="#f7e4f4"
            strokeLinejoin="round"
            strokeWidth="0.15"
          />
          <polygon
            points="814.98 47.77 814.98 52.44 809.46 44.58 814.98 41.39 814.98 45.32 820.5 48.45 820.5 50.95 814.98 47.77"
            fill="none"
            stroke="#f7e4f4"
            strokeLinejoin="round"
            strokeWidth="0.16"
          />
        </g>
        <g>
          <polygon
            points="1100.02 116.34 1100.02 125.27 1089.46 110.25 1100.02 104.15 1100.02 111.67 1110.57 117.66 1110.57 122.43 1100.02 116.34"
            fill="none"
            stroke="#4ff219"
            strokeLinejoin="round"
            strokeWidth="2.13"
          />
          <image
            width="97"
            height="96"
            transform="translate(1051.5 67)"
            xlinkHref="data:image/png;base64,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"
          />
          <line
            x1="1103.35"
            y1="118.97"
            x2="1103.35"
            y2="140.29"
            fill="none"
            stroke="#4ff219"
            strokeLinejoin="round"
            strokeWidth="2.13"
          />
          <line
            x1="1103.35"
            y1="119.97"
            x2="1103.35"
            y2="140"
            fill="none"
            stroke="#f7e4f4"
            strokeLinejoin="round"
            strokeWidth="0.3"
          />
          <polygon
            points="1100.02 116.34 1100.02 125.27 1089.46 110.25 1100.02 104.15 1100.02 111.67 1110.57 117.66 1110.57 122.43 1100.02 116.34"
            fill="none"
            stroke="#f7e4f4"
            strokeLinejoin="round"
            strokeWidth="0.3"
          />
        </g>
      </g>
    </g>
  );
};

export default Trope4;
